import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getEmployeeTravelData } from "../actions/getEmployeeTravelData";
import { IP } from "../config/IP";
import store from "../store/createStore";
import CustomizedInputBase from "./containers/SearchFields";
import TABLE from "./containers/Table";
import DocDetails from "./DocDetails";

function TabPanel(props) {
	const { children, value, index, ...other } = props;
	useEffect(() => {
		//console.log("TabPanel mounted");
		return () => {
			//console.log("TabPanel unmounted");
		};
	}, [props]);

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`wrapped-tabpanel-${index}`}
			aria-labelledby={`wrapped-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `wrapped-tab-${index}`,
		"aria-controls": `wrapped-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
}));

const EmployeeTravelProcessingScreen = (props) => {
	const classes = useStyles();
	const [value, setValue] = React.useState("one");
	const [DocId, setDocId] = React.useState("");
	const dispatch = useDispatch();
	const state = useSelector((state) => state);

	let inputs = {
		url: IP.nodeServer + "api/routesRules",
		method: "POST",
		data: [{ name: "Doc_type_id", value: parseInt(1) }],
	};
	let office_idv;
	try {
		office_idv = state.auth.user.office[0].office_id;
	} catch (e) {}

	const [office_id, setOffice_id] = React.useState();
	const [firstLoad, setFirstLoad] = React.useState(true);
	const [pageNumber, setPageNumber] = React.useState(0);
	const [numberRowPerPage, setNumberRowPerPage] = React.useState(5);
	const [totalRow, setTotalRow] = React.useState(20);

	const [dataloading, setDataloading] = React.useState({
		data: null,

		loading: true,
	});
	//console.log("dataloading=", dataloading);
	let actingOffices = {};
	try {
		actingOffices = state.userStatus.actingOfficeHierarchy[0].map(
			(y) => y.office_id
		);
	} catch (e) {}

	const [loadingCond, setLoadingCond] = React.useState(false);

	/*
			docsreq.docs.data.docs
			docsreq.docs.data.file
			docsreq.docs.data.docs
			docsreq.docs.data.limit
			docsreq.docs.data.page
			docsreq.docs.data.total
			docsreq.isDone
			*/

	const handleChange = (event, newValue, newDocId) => {
		//console.log("handleChange=", newValue);
		actingOffices = state.userStatus.actingOfficeHierarchy[0].map(
			(y) => y.office_id
		);

		setValue(newValue);
		if (newDocId) {
			//if (newValue === "two") {

			//getDocsById(inputs);

			setDocId(newDocId);
			//}
		}
		if (newValue === "one") {
			setOffice_id("");
			//console.log("handleChange 2=", newValue);
			setOffice_id(state.auth.user.office[0].office_id);

			setLoadingCond(false);
		} else {
			setOffice_id(state.auth.user.office[0].office_id);

			setLoadingCond(true);
		}
	};
	const handleChangeTablePage = (value) => {
		console.log("handleChangeTablePage value=", value);
		setPageNumber(value);
		setDataloading({
			data: null,

			loading: true,
		});
		actingOffices = state.userStatus.actingOfficeHierarchy[0].map(
			(y) => y.office_id
		);
		try {
			inputs = {
				url: IP.nodeServer + "api/getEmployeeTravelRecord",
				method: "POST",

				data: [
					{ name: "username", value: state.userStatus.status.username },
					{ name: "page", value: value + 1 },
					{ name: "limit", value: numberRowPerPage },
					{ name: "action", value: null },
				],
			};
			console.log("handleChangeTablePage clicked inputs=", inputs);
			dispatch(
				getEmployeeTravelData({
					url: IP.nodeServer + "api/getEmployeeTravelRecord",
					method: "POST",

					data: [
						{
							name: "Employee_ID",
							value: store.getState().employeeBioData.data.data.employeeInfo[0]
								.wbid,
						},
						{ name: "username", value: state.userStatus.status.username },
						{ name: "page", value: value + 1 },
						{ name: "limit", value: numberRowPerPage },
						{ name: "action", value: null },
					],
				})
			);
		} catch (e) {}

		setFirstLoad(false);
		console.log("handleChangeTablePage Clicked");

		console.log("pageNumber after handleChangeTablePage=", pageNumber);
	};
	const onChangeTableRowsPerPage = (value) => {
		console.log("onChangeTableRowsPerPage Clicked!");
	};

	/*
	
	*/
	//console.log("state.auth.user.office=", state.auth.user.office);

	//console.log("data in DocProcessingScreen=", dataloading.data);
	/*
	

	
	
	*/
	// before creating Docs Details
	//console.log("DocId before return=", DocId);
	//let details = DocId !== null && <DocDetails DocId={DocId} />;
	let details;

	//console.log("value DocId.DocId=" + DocId.length);
	if (value === "two" && DocId.length > 0) {
		details = DocId !== null && <DocDetails DocId={DocId} />;
	}
	const loadnew = () => {
		setDataloading({
			data: null,

			loading: true,
		});
		try {
			console.log(
				"store.getState().employeeTravel=",
				store.getState().employeeTravel
			);
			if (store.getState().employeeTravel.saved) {
				let currentstate = store.getState();

				let response = currentstate.employeeTravel.data;
				console.log("EmployeeTravelProcessingScreen response=", response);
				if (response.data) {
					console.log("axios response=", response);
					let doclist = response.data;
					let docsin = [];
					let respCondition = false;

					let data = [];

					console.log("doclist=", doclist);
					doclist.response.map((doclist, index) => {
						data.push({
							Employee_ID: doclist.Employee_ID,
							Creation_Date: doclist.Creation_Date,
							Employee_First_Name: doclist.Employee_First_Name,
							Employee_Last_Name: doclist.Employee_Last_Name,
							Employing_Airline: doclist.Employing_Airline,
							Employment_Status: doclist.Employment_Status,
							Fare: doclist.Fare,
							Fare_Issued: doclist.Fare_Issued,
							Fee: doclist.Fee,
							Fee_Issued: doclist.Fee_Issued,
							First_Name: doclist.First_Name,
							Issue_Date: doclist.Issue_Date,
							Last_Name: doclist.Last_Name,
							Master_User_ID: doclist.Master_User_ID,
							Middle_Name: doclist.Middle_Name,
							PTC: doclist.PTC,
							Process_Status: doclist.Process_Status,
							Record_Locator: doclist.Record_Locator,
							Routing: doclist.Routing,
							Status: doclist.Status,
							Tax: doclist.Tax,
							Tax_Detail: doclist.Tax_Detail,
							Tax_Issued: doclist.Tax_Issued,
							Ticket_Type: doclist.Ticket_Type,
							Ticketing_Airline: doclist.Ticketing_Airline,
							Total_Currency: doclist.Total_Currency,
							Total_Current: doclist.Total_Current,
							Total_Issued: doclist.Total_Issued,
							Transaction: doclist.Transaction,
							Transaction_Date: doclist.Transaction_Date,
							Travel_Mode: doclist.Travel_Mode,
							Cost_Center: doclist.Cost_Center,
							Country_Of_Residence: doclist.Country_Of_Residence,
						});
					});
					docsin = {
						title: "Available Documents",
						columns: [
							{ title: "Employee_ID", field: "Employee_ID" },
							{ title: "Creation_Date", field: "Creation_Date" },
							{ title: "Employee_First_Name", field: "Employee_First_Name" },
							{ title: "Employee_Last_Name", field: "Employee_Last_Name" },
							{ title: "Employing_Airline", field: "Employing_Airline" },
							{ title: "Employment_Status", field: "Employment_Status" },
							{ title: "Fare", field: "Fare" },
							{ title: "Fare_Issued", field: "Fare_Issued" },
							{ title: "Fee", field: "Fee" },
							{ title: "Fee_Issued", field: "Fee_Issued" },
							{ title: "First_Name", field: "First_Name" },
							{ title: "Issue_Date", field: "Issue_Date" },
							{ title: "Last_Name", field: "Last_Name" },
							{ title: "Master_User_ID", field: "Master_User_ID" },
							{ title: "Middle_Name", field: "Middle_Name" },
							{ title: "PTC", field: "PTC" },
							{ title: "Process_Status", field: "Process_Status" },
							{ title: "Record_Locator", field: "Record_Locator" },
							{ title: "Routing", field: "Routing" },
							{ title: "Status", field: "Status" },
							{ title: "Tax", field: "Tax" },
							{ title: "Tax_Detail", field: "Tax_Detail" },
							{ title: "Tax_Issued", field: "Tax_Issued" },
							{ title: "Ticket_Type", field: "Ticket_Type" },
							{ title: "Ticketing_Airline", field: "Ticketing_Airline" },
							{ title: "Total_Currency", field: "Total_Currency" },
							{ title: "Total_Current", field: "Total_Current" },
							{ title: "Total_Issued", field: "Total_Issued" },
							{ title: "Transaction", field: "Transaction" },
							{ title: "Transaction_Date", field: "Transaction_Date" },
							{ title: "Travel_Mode", field: "Travel_Mode" },
							{ title: "Cost_Center", field: "Cost_Center" },
							{ title: "Country_Of_Residence", field: "Country_Of_Residence" },
						],
						data: data,
					};
					console.log("docsin=", docsin);

					setDataloading({
						data: docsin,

						loading: false,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
					setTotalRow(response.data.total);
				}
			}
		} catch (e) {
			console.log("EmployeeTravelProcessingScreen error issue=", e);
		}
	};
	const handleSearch = (e, value) => {
		e.preventDefault();
		setDataloading({
			data: null,
			file: null,
			loading: true,
		});
		console.log("handleSearch=", value);
		inputs = {
			url: IP.nodeServer + "api/getDocs",
			method: "POST",

			office_id: office_id,
			actingOffices: actingOffices,
			searchKey: value,
			page: 1,
			limit: 100,
			action: null,
		};
		if (value) {
			try {
				dispatch(
					getEmployeeTravelData({
						url: IP.nodeServer + "api/getEmployeeTravelRecord",
						method: "POST",

						data: [
							{
								name: "Employee_ID",
								value: store.getState().employeeBioData.data.data
									.employeeInfo[0].wbid,
							},
							{ name: "username", value: state.userStatus.status.username },
							{ name: "page", value: 1 },
							{ name: "limit", value: 100 },
							{ name: "action", value: null },
						],
					})
				);
			} catch (e) {}
		} else {
			try {
				getEmployeeTravelData({
					url: IP.nodeServer + "api/getEmployeeTravelRecord",
					method: "POST",
					data: [
						{
							name: "Employee_ID",
							value: store.getState().employeeBioData.data.data.employeeInfo[0]
								.wbid,
						},
						{ name: "username", value: state.userStatus.status.username },
						{ name: "page", value: 1 },
						{ name: "limit", value: 100 },
						{ name: "action", value: null },
					],
				});
			} catch (e) {}
		}
		setFirstLoad(true);
	};

	useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));
		if (dataloading.loading) {
			console.log("firstLoad after handleChangeTablePage=", firstLoad);
			loadnew();
		}
	}, [store.getState().employeeTravel.saved]);

	console.log(
		"EmployeeTravelProcessingScreen dataloading.loading=",
		dataloading.loading
	);
	console.log(
		"EmployeeTravelProcessingScreen dataloading.data=",
		dataloading.data
	);
	return (
		<div className={classes.root}>
			<AppBar position="static">
				<Tabs
					value={value}
					onChange={handleChange}
					//onClick={handleClick}
					aria-label="wrapped label tabs example"
				>
					<Tab
						value="one"
						label="Document List"
						wrapped
						{...a11yProps("one")}
					/>
				</Tabs>
			</AppBar>

			<TabPanel value={value} index="one">
				{props.showSearch && (
					<CustomizedInputBase
						placeholder="Search for a Document"
						handleSearch={handleSearch}
					/>
				)}
				{dataloading.loading ? (
					"Loading"
				) : (
					<TABLE
						showSearch={false}
						Inputs={dataloading.data}
						handleChange={handleChange}
						issuer="EmployeeTravelProcessingScreen"
						showActions={false}
						handleChangeTablePage={handleChangeTablePage}
						onChangeTableRowsPerPage={onChangeTableRowsPerPage}
						pageNumber={pageNumber}
						firstLoad={firstLoad}
						numberRowPerPage={numberRowPerPage}
						totalRow={totalRow}
						showCustomizedToolbar={false}
					/>
				)}
			</TabPanel>
			<TabPanel value={value} index="two">
				{dataloading.loading ? "loading" : details}
			</TabPanel>
		</div>
	);
};
const mapDispatchToProps = (dispatch) => ({
	getEmployeeTravelData: (data) => dispatch(getEmployeeTravelData(data)),
});
const mapStateToProps = (state) => ({
	state,
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EmployeeTravelProcessingScreen);
